var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_video-play",
    "data-name": "vuesax/bold/video-play",
    transform: "translate(-236 -380)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "video-play"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51882",
    "data-name": "Group 51882"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H5.46V4.36H0Z",
    transform: "translate(245.27 382)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0V4.36H5.64C5.13,1.61,3.1.01,0,0Z",
    transform: "translate(252.23 382)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0V8.33c0,3.64,2.17,5.81,5.81,5.81h8.38c3.64,0,5.81-2.17,5.81-5.81V0ZM12.44,8.32l-2.08,1.2a2.6,2.6,0,0,1-1.27.38,1.641,1.641,0,0,1-.82-.21,2.051,2.051,0,0,1-.9-1.89V5.4a2.051,2.051,0,0,1,.9-1.89,2.03,2.03,0,0,1,2.09.17l2.08,1.2a2.052,2.052,0,0,1,1.19,1.73A2.057,2.057,0,0,1,12.44,8.32Z",
    transform: "translate(238 387.86)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M5.64,0C2.54.01.51,1.61,0,4.36H5.64Z",
    transform: "translate(238.13 382)",
    fill: "#7f7f7f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(236 380)",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.0dcca7aae4a4c5bde668fb1e6e1c0129.svg";
export { ForwardRef as ReactComponent };